<div class="invoice-modal-backdrop" (click)="cancelled.emit()"></div>
<div class="invoice-modal related-records-modal" role="dialog" aria-modal="true" aria-label="Related records selector">
  <div class="kt-card related-records-card">
    <div class="kt-card-header min-h-16 flex-wrap gap-3">
      <div>
        <h2 class="kt-card-title">Select {{ modeLabel }} related records</h2>
        <div class="text-xs text-secondary-foreground">{{ selections().size }} selected</div>
      </div>
      <button type="button" class="kt-btn kt-btn-outline" (click)="cancelled.emit()">Close</button>
    </div>

    <div class="kt-card-content p-5 related-records-content">
      <div class="related-records-filters">
        <input
          #generalSearch
          type="text"
          class="kt-input"
          placeholder="Search by any field..."
          [value]="searchTerm()"
          (input)="onSearchChange(generalSearch.value)"
        />
        <input
          #seriesSearch
          type="text"
          class="kt-input"
          placeholder="Exact Series Number..."
          [value]="seriesNumber()"
          (input)="onSeriesNumberChange(seriesSearch.value)"
        />
      </div>

      @if (errorMessage()) {
        <div class="kt-alert kt-alert-destructive mb-3">{{ errorMessage() }}</div>
      }

      <div class="related-records-table">
        <table class="kt-table">
          <thead>
            <tr>
              <th scope="col"></th>
              @if (isSecurityMode) {
                <th scope="col">Security ID</th>
              } @else {
                <th scope="col">Trade ID</th>
                <th scope="col">Deal ID</th>
                <th scope="col">Security ID</th>
              }
              <th scope="col">Cusip</th>
              <th scope="col">Isin</th>
              @if (!isSecurityMode) {
                <th scope="col">Tranche</th>
              }
              <th scope="col">Series Number</th>
              <th scope="col">Market Type</th>
              @if (!isSecurityMode) {
                <th scope="col">Trade Date</th>
                <th scope="col">Settlement Date</th>
              }
              <th scope="col">Maturity Date</th>
              <th scope="col">Allocated Amount</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading()) {
              <tr><td [attr.colspan]="visibleColumnCount" class="text-center py-6">Loading related records...</td></tr>
            } @else {
              @for (record of items(); track record.tradeId) {
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      [checked]="isSelected(record.tradeId)"
                      (change)="toggleSelection(record, $any($event.target).checked)"
                    />
                  </td>
                  @if (isSecurityMode) {
                    <td>{{ record.securityId }}</td>
                  } @else {
                    <td>{{ record.tradeId || '-' }}</td>
                    <td>{{ record.dealId || '-' }}</td>
                    <td>{{ record.securityId || '-' }}</td>
                  }
                  <td>{{ record.cusip || '-' }}</td>
                  <td>{{ record.isin || '-' }}</td>
                  @if (!isSecurityMode) {
                    <td>{{ record.tranche || '-' }}</td>
                  }
                  <td>{{ record.seriesNumber || '-' }}</td>
                  <td>{{ record.marketType || '-' }}</td>
                  @if (!isSecurityMode) {
                    <td>{{ formatDate(record.tradeDate) }}</td>
                    <td>{{ formatDate(record.settlementDate) }}</td>
                  }
                  <td>{{ formatDate(record.maturityDate) }}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      class="kt-input kt-input-sm text-end w-32"
                      [ngModel]="amountFor(record.tradeId)"
                      [disabled]="!isSelected(record.tradeId)"
                      (ngModelChange)="updateAmount(record, $event)"
                    />
                  </td>
                </tr>
              } @empty {
                <tr><td [attr.colspan]="visibleColumnCount" class="text-center text-secondary-foreground py-6">No matching records found.</td></tr>
              }
            }
          </tbody>
        </table>
      </div>

      <div class="related-records-footer">
        <div class="text-sm text-secondary-foreground">
          {{ totalRecords() }} records · Page {{ pageNumber() }} of {{ totalPages() || 1 }}
        </div>
        <div class="flex items-center gap-2">
          <button type="button" class="kt-btn kt-btn-sm kt-btn-outline" [disabled]="pageNumber() <= 1" (click)="goToPage(pageNumber() - 1)">Previous</button>
          <button type="button" class="kt-btn kt-btn-sm kt-btn-outline" [disabled]="pageNumber() >= totalPages()" (click)="goToPage(pageNumber() + 1)">Next</button>
          <button type="button" class="kt-btn kt-btn-outline" (click)="cancelled.emit()">Cancel</button>
          <button type="button" class="kt-btn kt-btn-primary" (click)="save()">Save selection</button>
        </div>
      </div>
    </div>
  </div>
</div>
